"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomAlert = void 0;
const styles_1 = require("@mui/material/styles");
const Alert_1 = __importDefault(require("@mui/material/Alert"));
exports.CustomAlert = (0, styles_1.styled)(Alert_1.default)(({ theme }) => ({
    boxShadow: theme.shadows[5]
}));
